import axios  from 'axios';
import vapor  from 'laravel-vapor';
import lodash from 'lodash';
import moment from 'moment-timezone';
import Pusher from 'pusher-js';

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const csrfToken = document.querySelector('meta[name="csrf-token"]');
if (csrfToken) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.getAttribute('content');
}

window.Vapor = vapor;

window.Vapor.withBaseAssetUrl(import.meta.env.VITE_VAPOR_ASSET_URL);

window.moment = moment;

window.moment.updateLocale('en', {
    week: {
        dow: 0,
        doy: 4,
    },
});

window._ = lodash;

window.Pusher = Pusher;